import { render } from "./AccountInfoComponent.vue?vue&type=template&id=507c0dba"
import script from "./AccountInfoComponent.vue?vue&type=script&lang=js"
export * from "./AccountInfoComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/frontend/account/accountInfo/AccountInfoComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "507c0dba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('507c0dba', __exports__)) {
    api.reload('507c0dba', __exports__)
  }
  
  module.hot.accept("./AccountInfoComponent.vue?vue&type=template&id=507c0dba", () => {
    api.rerender('507c0dba', render)
  })

}


export default __exports__